import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { HomePage } from "./pages/HomePage";
import { FounderPage } from "./pages/FounderPage";
import { ProficiencyPage } from "./pages/ProficiencyPage";
import { ProfessionalServicesPage } from "./pages/ProfessionalServicesPage";
import { SolutionsPage } from "./pages/SolutionsPage";
import { ModusOperandiPage } from "./pages/ModusOperandiPage";
import { InsightsPage } from "./pages/InsightsPage";
import { EngagePage } from "./pages/EngagePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/proficiency" element={<ProficiencyPage />} />
            <Route path="/professional-services" element={<ProfessionalServicesPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/modus-operandi" element={<ModusOperandiPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/engage" element={<EngagePage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
